import metaPixel from './metaPixel.js';
import tddPixel from './tdd.js';
import googleTags from './google.js';
import { parseEventAndPayload } from './utils.js';

var randomKey = 'd24buQs3x5ag';
var debug = false;
var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!debug) {
        return;
    }
    // eslint-disable-next-line no-console
    console.info.apply(console, ['[externalTracking]'].concat(args));
};
function enableDebug() {
    debug = true;
    metaPixel.enableDebug();
    tddPixel.enableDebug();
    googleTags.enableDebug();
}
function setIdentity(identity) {
    metaPixel.setIdentity(identity);
}
function track(event, params, pixelContainer) {
    var _a;
    if (params === null || params === void 0 ? void 0 : params[randomKey]) {
        enableDebug();
        params[randomKey] = undefined;
    }
    if (!(params === null || params === void 0 ? void 0 : params.v_id) || !(pixelContainer === null || pixelContainer === void 0 ? void 0 : pixelContainer.brandId) || !((_a = pixelContainer === null || pixelContainer === void 0 ? void 0 : pixelContainer.pixels) === null || _a === void 0 ? void 0 : _a.length)) {
        log('track required missing params', event, params, pixelContainer);
        return;
    }
    var _b = parseEventAndPayload(event, params), eventName = _b.eventName, eventPayload = _b.eventPayload;
    if (!eventName || !(eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.stacklineSku)) {
        log('track event not supported', event, params, pixelContainer);
        return;
    }
    metaPixel === null || metaPixel === void 0 ? void 0 : metaPixel.track(pixelContainer.brandId, pixelContainer.pixels, eventName, eventPayload);
    googleTags === null || googleTags === void 0 ? void 0 : googleTags.track(pixelContainer.brandId, pixelContainer.pixels, eventName, eventPayload);
    tddPixel === null || tddPixel === void 0 ? void 0 : tddPixel.install(pixelContainer.brandId, pixelContainer.pixels, eventName, eventPayload);
}

export { enableDebug, setIdentity, track };
//# sourceMappingURL=externalTracking.js.map
